import { useSearchParams } from 'react-router-dom';
import { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router';

const SHOW_ARCHIVED_RECORDS_QUERY_PARAM = 'showArchived';

export const useArchivedPage = (upPageUrl: string | undefined) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const showingArchived = searchParams.get(SHOW_ARCHIVED_RECORDS_QUERY_PARAM) === 'true';

  const originallyLoadedNonArchived = useRef<boolean>(false);

  const navigateToArchivedPage = useCallback(() => {
    if (showingArchived) {
      return;
    }
    originallyLoadedNonArchived.current = true;
    setSearchParams({
      [SHOW_ARCHIVED_RECORDS_QUERY_PARAM]: 'true',
    });
  }, [showingArchived]);

  const navigateBack = useCallback(() => {
    if (!showingArchived && upPageUrl) {
      navigate(upPageUrl);
    } else if (!showingArchived) {
      return;
    } else if (originallyLoadedNonArchived.current) {
      navigate(-1);
    } else {
      setSearchParams({});
    }
  }, [showingArchived, upPageUrl]);

  return [showingArchived, navigateToArchivedPage, navigateBack] as const;
};
